import React from 'react';

const TabButton = ({ active, children, onClick }) => (
  <button
    className={`px-4 py-2 font-semibold rounded-t-lg ${active ? 'bg-gray-700 text-white' : 'bg-gray-600 text-gray-300'}`}
    onClick={onClick}
  >
    {children}
  </button>
);

export default TabButton;
